function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  id: "Line_87",
  "data-name": "Line 87",
  y2: 33.391,
  transform: "translate(16.695)",
  fill: "none",
  stroke: "#1583dd",
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "Line_88",
  "data-name": "Line 88",
  y2: 33.391,
  transform: "translate(33.391 16.695) rotate(90)",
  fill: "none",
  stroke: "#1583dd",
  strokeWidth: 1
});

function SvgPlusButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_794",
    "data-name": "Group 794",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.391,
    height: 33.391,
    viewBox: "0 0 33.391 33.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.2cf69405.svg";
export { ForwardRef as ReactComponent };